import { render, staticRenderFns } from "./ModifyDateVariable.vue?vue&type=template&id=6c773aa6&"
import script from "./ModifyDateVariable.vue?vue&type=script&lang=js&"
export * from "./ModifyDateVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports